import Swiper from 'swiper/bundle';

export const testimonials = () => {
  function setAlignFullCssVar() {
    // Create the measurement node
    let scrollDiv = document.createElement('div');
    scrollDiv.className = 'scrollbar-measure';
    document.body.appendChild(scrollDiv);

    // Get the scrollbar width & half width
    let scrollBarWidth = window.innerWidth - scrollDiv.clientWidth;
    let alignFullOffset = scrollBarWidth / 2;

    // console.log(window.innerWidth);
    // console.log(scrollDiv.clientWidth);
    // console.warn(scrollBarWidth); // Mac:  15

    // Delete the DIV
    document.body.removeChild(scrollDiv);

    //Get .alignfull element
    let root = document.documentElement;
    let root_style = getComputedStyle(root);

    //Set --alignfull-offset css var
    let cssVarAlignFullOffset =
      root_style.getPropertyValue('--alignfull-offset');
    if (alignFullOffset + 'px' !== cssVarAlignFullOffset) {
      root.style.setProperty('--alignfull-offset', alignFullOffset + 'px');
    }
  }
  //gallery sliders
  const swiperBlocks = document.querySelectorAll('.testimonial-swiper');

  const swiperInstances = [...swiperBlocks].map((block) => {
    const $block = $(block);

    // removes classes that starts with wp- & is-flex;
    $block.removeClass((_, css) => (css.match(/\bwp-\S+/g) || []).join(' '));
    $block.removeClass((_, css) =>
      (css.match(/\bis-flex\S+/g) || []).join(' '),
    );

    $block
      .addClass('swiper')
      .children()
      .addClass('swiper-slide')
      .wrapAll('<div class="swiper-wrapper">');

    $block.append('<div class="swiper-pagination">');

    const instance = new Swiper(block, {
      loop: true,
      slidesPerView: 'auto',
      autoHeight: true,
      speed: 800,
      // loopedSlides: 8,
      disableOnInteraction: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      // effect: 'fade',
      // fadeEffect: {
      //   crossFade: true,
      // },
      autoplay: {
        delay: 5000,
      },
      breakpoints: {
        // when window width is >= 1080px
        1080: {
          // allowTouchMove: false,
        },
      },
      // freeMode: true,
      // navigation: {
      //   nextEl: '.swiper-button-next',
      //   prevEl: '.swiper-button-prev',
      // },
      on: {
        init: function () {
          // console.log('custom'); // this works
          //setAlignFullCssVar();
        },
        imagesReady: function () {
          setAlignFullCssVar();
        },
      },
    });

    return instance;
  });

  swiperInstances.forEach((swiper) => {
    $(swiper.wrapperEl).mouseenter(function () {
      swiper.autoplay.stop();
    });
    $(swiper.wrapperEl).mouseleave(function () {
      swiper.autoplay.start();
    });
    // $(swiper.wrapperEl)
    //   .closest('.wp-block-query')
    //   .find('.project-filters a')
    //   .click(function () {
    //     swiper.updateSlides();
    //   });
  });
};
